// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import {
  getFirestore, doc, updateDoc, getDocs, collection
} from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
if (getApps().length < 1) {
    initializeApp(firebaseConfig);
} else {
    console.log("Firebase app already exists.")
}

// init services
const db = getFirestore();

const docRef = doc(db, "app", "9MbO4rDRH1XHKcSgaiP2");

const colRef = collection(db, "app");

export default class FirebaseService {


    // Gets Data for wordOfDay
    static async getWordData() {
        try {
            const data = await getDocs(colRef);
            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
            
            // Assume you want to get `timer.day` from the first document
            return({
                "word": filteredData[0]?.media.wordOfDay.word,
                "defs": filteredData[0]?.media.wordOfDay.definitions,
                "img": filteredData[0]?.media.wordOfDay.image
            });
    
        } catch (err) {
            console.error(err);
        }
    };

    static async setWordData(wordData) {
        const imageAPI = await fetch(`https://pixabay.com/api/?key=32259448-4a754c36feddda25c19fce750&q=${wordData.word}&image_type=photo`);
        const imageJSON = await imageAPI.json();
        const imageURL = await imageJSON.hits[0].webformatURL;

        const definitionsArray = wordData?.meanings?.map((meaning) => ({
            partOfSpeech: meaning.partOfSpeech,
            definitions: meaning.definitions.map((obj) => obj.definition),
        })) || [];

        try {
            await updateDoc(docRef, {
                [`media.wordOfDay.word`]: wordData.word,
                [`media.wordOfDay.definitions`]: definitionsArray,
                [`media.wordOfDay.image`]: imageURL,
            });
        } catch (err) {
            console.error(err);     
        }
    }
}
